<h1>THE VENUE</h1>
<h2>Main conference and workshops</h2>
<p> Our main venue for both the main conference and workshops is <a
        href="https://www.uniroma3.it/">Roma Tre University</a> </p>

<h2 style="margin-top: 2.5rem; color: #2c3e50; font-size: 1rem;">
    <b>October 5th, 2026 <br>  INSERIRE INDIRIZZO</b>
</h2>
<!-- <p align="center">
    <img src="https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqJRjF--ZS2EYjwQlRWbLBzjoln2oeQnK_gby_j0KkSR0zv6wVjLyWlCQQGrZogLj5iW58NuYnWZs6ZX8O75BubYRumw0oMllh5PCVLe7vnT65V2DIQO8u4ckh1e05MaWN3KQRaZw=s1360-w1360-h1020-rw" alt="image" border="0" style="width:400px;height:300px;">
</p> -->


<h2 style="margin-top: 2.5rem; color: #2c3e50; font-size: 1rem;">October 6th, 2026 <br> INSERIRE INDIRIZZO </h2>
  <!-- <p align="center">
    <img src="https://lh3.googleusercontent.com/gps-cs-s/AC9h4nqquwBMhACjmH-XpkiVWuFxk_sRpCQqkycfV0JP9nARpDFxBN_fY5Cvc5PZspi-caxpwDb7yI4TkKiJHMV9YFNmZS27VUxL0HWwdDf24sheyGEJPmb_urhBKEUDJyHtw0cwMsroKA=s1360-w1360-h1020-rw" alt="image" border="0" style="width:400px;height:300px;">
</p> -->

<hr>
 <p align="center">
 <h2 align="center" style="margin-top: 2.5rem; color: #2c3e50; font-size: 1.5rem;">How to find us</h2>
<p>
  <p align="center">
  <img src="https://i.ibb.co/nNNf2kgx/0af8d7e0-46d5-45c2-9429-77b208e6d119.jpg" alt="0af8d7e0-46d5-45c2-9429-77b208e6d119" width="1280" height="678" data-is360="0" data-load="full" class="" style="width: 826px; height: 437.522px; display: block;">
</p>

  
